import { PrimitiveValueObjectDate } from '@/domain/primitiveValueObjectDate';

/**
 * 測定日
 */
export class MeasureDate extends PrimitiveValueObjectDate {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: Date): MeasureDate {
    return new MeasureDate(value);
  }

  /** ラベル */
  static get label(): string {
    return '測定日';
  }

  /**
   * プレースホルダー
   */
  static get placeholder(): Date {
    return new Date('2022-01-01');
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }
}
